import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setDelivery, setSelectedStore } from '../Actions/Checkout.action';
import { translate } from '../Services/translation';

const CheckoutDeliveryMethods = ({ errors }) => {
    const dispatch = useDispatch();
    const { deliveryMethods, selectedDeliveryMethod, selectedStore } = useSelector(
        (state) => state.checkout.payload
    );

    var selectedStoreId = selectedStore && selectedStore != '' ? selectedStore : window.__litium.preloadState.selectStoreModal.stores.find((store) => store.isSelected == true).storeId;
    var selectedStoreObject = window.__litium.preloadState.selectStoreModal.stores.find((store) => store.storeId == selectedStoreId);

    useEffect(() => {
        dispatch(setSelectedStore(selectedStoreId))
    }, []);
    
    return (
        <Fragment>
            <div className="row">
                <h3 className="checkout__section-pre-title">3/4</h3>
                <h3 className="checkout__section-title">
                    {translate('checkout.delivery.title')}
                </h3>
            </div>
            {deliveryMethods && deliveryMethods.length > 0 && (
                <section className="row checkout-info__container checkout-info__container-delivery">
                    {deliveryMethods.map((method) => (
                        <Fragment key={method.id}>
                            <label className={`columns small-6 checkout-info__container--delivery-option ${method.id === selectedDeliveryMethod?.id ? 'checkout-info__container--delivery-option-active' : 'checkout-info__container--delivery-option-not-active'}`}>
                                <input
                                    type="radio"
                                    name="deliveryMethods"
                                    className="checkout-info__checkbox-radio"
                                    value={method.id}
                                    checked={method.id === selectedDeliveryMethod?.id}
                                    onChange={() => dispatch(setDelivery(method))}
                                />
                                <span className='checkout-info__delivery-title'>
                                    <img src={method.imageUrl} alt={method.name} />
                                    <b>{method.name} </b> <span>{Math.round(parseFloat(method.formattedPrice))} kr</span>
                                </span>

                                {method.id == 'DirectShipment:pickupInStore' && selectedDeliveryMethod?.id === 'DirectShipment:pickupInStore' &&
                                    <div className="select-store">
                                        <label
                                            className="form__label"
                                            htmlFor="selectStore"
                                        >
                                            {translate('code.checkout.delivery.pick.store')}
                                        </label>
                                        <select
                                            className="form__input"
                                            name="selectStore"
                                            value={selectedStoreId}
                                            onChange={(event) => dispatch(setSelectedStore(event.target.value))}
                                        >
                                            {window.__litium.preloadState.selectStoreModal.stores.map((store) => (
                                                <option value={store.storeId} key={`store-${store.storeId}`}>
                                                    {store.name}
                                                </option>
                                            ))}
                                        </select>

                                        <div className='select-store__text'>
                                            {/* This shall be saved and activated when Jicon is ready some time in the future*/}
                                            {/* <div className="row">
                                                <span className="columns small-6 info checkout-icon--calendar">
                                                    {translate("code.checkout.delivery.calendar.ready.pickup")}
                                                </span>
                                                <span className="columns small-6 value">
                                                    {selectedStoreObject.name}
                                                </span>
                                            </div> */}
                                            <div className="row">
                                                <span className="columns small-6 info checkout-icon--address">
                                                    {translate("code.checkout.delivery.address")}
                                                </span>
                                                <span className="columns small-6 value">
                                                    {selectedStoreObject.address}
                                                </span>
                                            </div>
                                            <div className="row">
                                                <span className="columns small-6 info checkout-icon--clock">
                                                    <ul className='select-store__week-days '>
                                                        {selectedStoreObject.openHoursAndDays && selectedStoreObject.openHoursAndDays.map((x, index) =>{
                                                            return(
                                                                <li key={index}>
                                                                    {x.weekday}
                                                                </li>
                                                            )
                                                        })}
                                                    </ul> 
                                                </span>
                                                <span className="columns small-6 value">
                                                <ul className='select-store__open-hours'>
                                                    {selectedStoreObject.openHoursAndDays && selectedStoreObject.openHoursAndDays.map((x, index) =>{
                                                            return(
                                                                <li key={index}>
                                                                    { x.openinghour}
                                                                </li>
                                                            )
                                                        })}        
                                                </ul>
                                                </span>
                                            </div>
                                            <div className="row">
                                                <span className="columns small-6 info checkout-icon--phone">
                                                    {translate("code.checkout.delivery.phone.number")}
                                                </span>
                                                <span className="columns small-6 value">
                                                    {selectedStoreObject.organizationStorePhone}
                                                </span>
                                            </div>
                                            <div className="row">
                                                <span className="columns small-6 info checkout-icon--mail">
                                                    {translate("code.checkout.delivery.mail")}
                                                </span>
                                                <span className="columns small-6 value">
                                                    {selectedStoreObject.organizationStoreMail}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </label>
                            <div className="columns small-6 checkout-info__container--delivery-info">
                                <div className="small-1 part-delivery-info-image-container">
                                    <img src={method.imageUrl} alt={method.name} />
                                </div>
                                <div className="small-11 part-delivery-info">
                                    <div><span className="delivery-title">{translate('code.checkout.delivery.' + method.id.split(':')[1].toLowerCase() + '.title')}</span></div>
                                    <div><span className="delivery-text">{translate('code.checkout.delivery.' + method.id.split(':')[1].toLowerCase() + '.text')}</span></div>
                                </div>
                            </div>
                        </Fragment>
                    ))}
                </section>
            )}
            <div className="row">
                {errors['selectedDeliveryMethod'] && (
                    <span className="form__validator--error form__validator--top-narrow">
                        {errors['selectedDeliveryMethod'][0]}
                    </span>
                )}
            </div>
        </Fragment>
    );
};

export default CheckoutDeliveryMethods;
